import React, { useEffect, useState } from "react";
import AccHeader from "../components/AccountHeader";
import Table from "../../core/components/Table/Table";
import FundTransferForm from "../components/FundTransferForm";

import { selectAccount } from "../../dashboard/redux/accountSlice";
import { useSelector } from "react-redux";
import { getLatestTransactionList } from "../../../network/Apiservices";
import AccountSkimmer from "../components/AccountSkimmer";

interface AccountProps {
  // Define your prop types here
}

const defaultState = {
  loading: true,
  transactionList: [],
};

const Account: React.FC<AccountProps> = (props) => {
  const [state, setState] = useState(defaultState);

  const account = useSelector(selectAccount);

  useEffect(() => {
    getLatestTransList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getLatestTransList = async () => {
    console.log("account_getLatestTransList->{}", account);

    let response = await getLatestTransactionList(
      account?.value.id ? account.value.id : ""
    );
    if (response?.data?.transactions) {
      setState({
        ...state,
        transactionList: response.data.transactions.slice(0, 5),
        loading: false,
      });
    }
  };

  if (state.loading) {
    return <AccountSkimmer />;
  }
  return (
    <div className="flex flex-col w-full gap-10 justify-around">
      <AccHeader />

      <div className="flex lg:flex-row md:flex-col w-full pl-7 pr-6 gap-6">
        <div className="flex flex-col lg:w-7/12 xl:w-7/12 2xl:w-9/12 3xl:w-3/4">
          <Table transactionsList={state.transactionList} />
        </div>
        <div className="flex w flex-col lg:w-5/12 xl:w-5/12 2xl:w-3/12 3xl:w-1/4 mb-5">
          <FundTransferForm />
        </div>
      </div>
    </div>
  );
};

export default Account;
